import React, { useState } from "react";
import imgGizi1 from "../../../assets/img_major03_1.jpg";
import imgGizi2 from "../../../assets/img_major03_2.jpg";
import imgGizi3 from "../../../assets/img_major03_3.jpg";

import imgGiziSub1 from "../../../assets/img_major03_sub1.png";
import imgGiziSub2 from "../../../assets/img_major03_sub2.png";
import imgGiziSub3 from "../../../assets/img_major03_sub3.png";

const MajorTab3 = props => {
    return (
        <>
            {/* 기지국/중계기 운용관리 */}
            <div className="tab-cont">
                <h2 className="major-in-h2">
                    BUSINESS <em>사업소개</em>
                </h2>
                <p className="major-sbj">{props.title}</p>
                <div className="person-gray-wrap gray-back-bg">
                    <div className="major-img-wrap">
                        <ul>
                            <li>
                                <img src={imgGizi1} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi2} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi3} alt="이미지" />
                            </li>
                        </ul>
                    </div>
                    <div className="mojor-business-wrap">
                        {/* <p className="cate">주요사업 업무</p> */}
                        <ul className="list">
                            <li className="hoverWraps">
                                <p className="hoverText">5G 특화망 기간통신서비스 제공</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- KT 그룹사 최초 5G 특화망 기간통신사업자 면허 획득</p>
                                        <p>- 주파수 할당 신청 및 승인</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">고객사 통신 인프라 장비 (Core, DU, RU)관제, 운용, 유지보수</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 5G 특화망 24H 모니터링 및 장애대응</p>
                                        <p>- 5G 특화망 통신 인프라 장비(기지국) 관리 및 점검</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <p className="mojor-text">이동국(가입자단말기)과 이동전화 교환국 사이에 위치하여 이동국과의 무선전송과 교환국의 요청 있을 경우 통화중인 이동국의 신호강도를 측정하여 제공함으로써 이동전화 교환국이 이동국의 이동상황을 파악하는데 필요한 정보를 제공합니다.</p> */}

                    <p className="major-sbj">5G특화망은</p>
                    <p className="mojor-text">특정지역에 도입하려는 서비스에 특화된 맞춤형 네트워크로서,</p>
                    <p className="mojor-text">스마트 공장, 종합병원 등 산업용도로 이용되고 있습니다.</p>
                    <p className="mojor-text">누구라도 5G특화망 주파수를 이용하여 융합서비스를 가능하게 만들어주는 기술입니다.</p>

                    <img src={imgGiziSub1} alt="이미지" style={{ marginBottom: 20 }} />

                    <p className="mojor-text">kt MOS북부는 2022년 10월, 기간통신사업자 등록 허가와 주파수 할당을 완료하였습니다.</p>
                    <p className="mojor-text">2001년부터 이어온 무선통신망 설비관리·유지보수 노하우로 안정적인 이음5G 서비스를 제공합니다.</p>

                    <img src={imgGiziSub2} alt="이미지" style={{ marginTop: 30 }} />

                    <div className="mojor-business-wrap" style={{ marginTop: 80, paddingBottom: 0, marginBottom: 0 }}>
                        <ul className="list">
                            <li className="hoverWraps">
                                <p className="hoverText">서비스특징</p>
                            </li>
                        </ul>
                    </div>
                    <img src={imgGiziSub3} alt="이미지" style={{ marginTop: 0 }} />
                </div>
            </div>
        </>
    );
};

export default MajorTab3;
